export default __webpack_public_path__ + "static/media/PlusCircle.263acbf6.svg";